import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Consistent page container with max-width and centering
 * Applied at layout level - do not use directly in page components
 *
 * Design tokens:
 * - max-w-7xl: Consistent max width matching navbar
 * - px-6: Horizontal padding from theme spacing
 * - py-8: Vertical padding from theme spacing
 */
export function PageContainer(t0) {
  const $ = _c(3);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `mx-auto w-full max-w-7xl px-6 py-8 ${className}`;
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}